import moment from 'moment';

/**
 *
 * @param {string} deliveryFrom
 * @param {string} deliveryTo
 * @param {string} customeTimeText
 * @param {string} orderUpdateAt
 * @return {object}
 */
export const getDeliveryTimeText = (
  deliveryFrom,
  deliveryTo,
  customeTimeText,
  orderUpdateAt,
  deliveryPartnerStatus
) => {
  const deliveryTimeData = {
    text: '',
    isInfoRequired: false,
  };

  // If Custom delivery time text available
  if (customeTimeText) {
    deliveryTimeData.text = `Estimated delivery: ${customeTimeText}.`;
    deliveryTimeData.isInfoRequired = true;
  } else {
    if (deliveryPartnerStatus > 0) {
      const currentTime = moment(moment().format('YYYY-MM-DD HH:mm:ss'));
      deliveryFrom = moment(deliveryFrom);
      deliveryTo = moment(deliveryTo);
      orderUpdateAt = moment(orderUpdateAt);

      const gapBetweenDeliveryTime = moment.duration(deliveryTo.diff(deliveryFrom));
      const differenceInHours = gapBetweenDeliveryTime.asHours();

      // if difference is more than or equal to 24hrs
      if (differenceInHours >= 24) {
        if (currentTime.valueOf() > deliveryTo.valueOf()) {
          deliveryTimeData.text = `Estimated Delivery: ${moment(deliveryFrom).format(
            'DD-MM-YYYY'
          )} to ${moment(deliveryTo).format('DD-MM-YYYY')}.`;
          deliveryTimeData.isInfoRequired = true;
        } else {
          deliveryTimeData.text = `Your order will be delivered between ${moment(
            deliveryFrom
          ).format('DD-MM-YYYY')} to ${moment(deliveryTo).format('DD-MM-YYYY')}.`;
          deliveryTimeData.isInfoRequired = false;
        }
      }
      // if difference is less than to 24hrs
      else if (differenceInHours > 0 && differenceInHours < 24) {
        let timeFrom = moment.duration(deliveryFrom.diff(orderUpdateAt));
        let timeTo = moment.duration(deliveryTo.diff(orderUpdateAt));
        let isMin = true;

        if (moment.duration(deliveryFrom.diff(orderUpdateAt)).asMinutes() > 60) {
          timeFrom = timeFrom.asHours();
          timeTo = timeTo.asHours();
          isMin = false;
        } else {
          timeFrom = timeFrom.asMinutes();
          timeTo = timeTo.asMinutes();
        }

        if (currentTime.valueOf() > deliveryTo.valueOf()) {
          deliveryTimeData.text = `Estimated Delivery: ${Math.ceil(timeFrom)}-${Math.ceil(
            timeTo
          )} ${isMin ? 'mins' : 'hrs'}.`;
          deliveryTimeData.isInfoRequired = true;
        } else {
          deliveryTimeData.text = `Your order will be delivered in the next ${Math.ceil(
            timeFrom
          )}-${Math.ceil(timeTo)} ${isMin ? 'minutes' : 'hours'}.`;
          deliveryTimeData.isInfoRequired = false;
        }
      }
    } else {
      deliveryTimeData.text = `Tracking details would be available once the order is shipped.`;
      deliveryTimeData.isInfoRequired = true;
    }
  }

  return deliveryTimeData;
};
